import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/system/';
/**
 *
 *
 */
export default {
  operationHistory(data) {
    return axios.get(userBastUrl + 'operationHistory', {
      params: data
    });
  }
}
